import { Component, ViewChild, ElementRef } from '@angular/core';

import { BaseComponent } from '../_base.component';

/**
 * @ignore
 */
@Component({
  selector: 'uex-input-date',
  templateUrl: './date.component.html',
  host: {
    class: 'uex-input-date'
  }
})
export class InputDateComponent extends BaseComponent<string> {
  @ViewChild('actionButton', { static: false }) private _action_button: ElementRef;

  public getBodyWidth(): string {
    if (this._action_button) {
      const style = window.getComputedStyle(this._action_button.nativeElement);
      return `calc(100% - ${style.width})`;
    }
    return null;
  }

}
